import { InjectionToken } from "@angular/core";

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('auth-config');

export interface SessionConfig {
    expirationMinutes?: number; // Default: 30
    heartbeatInterval?: number; // Default: 5 minutes
    activityDebounce?: number; // Default: 1000ms
    enableActivityMonitoring?: boolean; // Default: true
    tokenResponseHeader?: string; // Default: 'authorization'
    heartbeatEndpoint?: string; // Default: '/account/roles'
    publicUrls?: string[]; // Default: [/login, /logout, /forgot-password]
}

export interface AuthConfig {
    authInvalidRedirectUrl: string;
    authLoginUrl: string;
    authLogoutUrl: string;
    authForgotPasswordUrl: string;
    application: 'optometrist-zone' | 'customer-zone';
    sessionConfig?: SessionConfig;
}

export const DEFAULT_SESSION_CONFIG: Required<SessionConfig> = {
    expirationMinutes: 30,
    heartbeatInterval: 5,
    activityDebounce: 1000,
    enableActivityMonitoring: true,
    tokenResponseHeader: 'authorization',
    heartbeatEndpoint: '/account/roles',
    publicUrls: ['/login', '/logout', '/forgot-password']
};
